<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-title>Scheduled Rides</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon name="close-outline" slot="icon-only"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div *ngIf="scheduledRides$ | async as rides; else loading">
        <div *ngIf="rides.length === 0" class="empty-state">
            <ion-icon name="calendar-outline"></ion-icon>
            <h3>No Scheduled Rides</h3>
            <p>Your upcoming scheduled trips will appear here.</p>
        </div>

        <ion-list lines="none" *ngIf="rides.length > 0">
            <ion-card *ngFor="let ride of rides" class="scheduled-ride-card">
                <ion-card-content>
                    <div class="ride-header">
                        <div class="time-box">
                            <span class="date">{{ formatDate(ride.scheduledAt) }}</span>
                        </div>
                        <ion-badge color="primary">Scheduled</ion-badge>
                    </div>

                    <div class="location-details">
                        <div class="loc pickup">
                            <ion-icon name="ellipse-outline"></ion-icon>
                            <span>{{ ride.Rider_Location }}</span>
                        </div>
                        <div class="loc destination">
                            <ion-icon name="square"></ion-icon>
                            <span>{{ ride.Rider_Destination }}</span>
                        </div>
                    </div>

                    <div class="ride-footer">
                        <div class="price">Estimated: {{ ride.price | currency }}</div>
                        <ion-button fill="clear" color="danger" (click)="cancelRide(ride.id)">
                            Cancel
                        </ion-button>
                    </div>
                </ion-card-content>
            </ion-card>
        </ion-list>
    </div>

    <ng-template #loading>
        <div class="ion-text-center">
            <ion-spinner></ion-spinner>
        </div>
    </ng-template>
</ion-content>